import { render, staticRenderFns } from "./SecondHead.vue?vue&type=template&id=94cf35ce&scoped=true&"
import script from "./SecondHead.vue?vue&type=script&lang=js&"
export * from "./SecondHead.vue?vue&type=script&lang=js&"
import style0 from "./SecondHead.vue?vue&type=style&index=0&id=94cf35ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cf35ce",
  null
  
)

export default component.exports